import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'wwd-manual-automated-testing',
  templateUrl: './manual-automated-testing.component.html',
  styleUrls: ['./manual-automated-testing.component.scss']
})
export class ManualAutomatedTestingComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
